import React, { useState } from 'react';
import { Heart } from 'lucide-react';
import authService from '../services/AuthService';
import { API_BASE } from '../consts';

const FavoriteButton = ({ deal, onFavoriteChange }) => {
    const [isFavorited, setIsFavorited] = useState(!!deal.favorite_id);
    const [favoriteId, setFavoriteId] = useState(deal.favorite_id);
    const [loading, setLoading] = useState(false);
    const identifier = deal.marketplace === 'amazon' ? (
        deal?.marketplace_data?.asin
    ) : (
        deal.marketplace === 'walmart' ? (
            deal?.marketplace_data?.item_id
        ) : (
            deal.marketplace === 'ebay' ? (
                deal?.marketplace_data?.upc
            ) : ''
        )
    );

    const getProductId = () => {
        if (deal.marketplace === 'amazon') {
            return deal.marketplace_data?.asin;
        } else if (deal.marketplace === 'walmart') {
            return deal.marketplace_data?.item_id;
        } else if (deal.marketplace === 'ebay') {
            return deal.marketplace_data?.ebay_search_link;
        }
        return null;
    };

    const handleToggleFavorite = async (e) => {
        e.stopPropagation();
        setLoading(true);

        try {
            if (isFavorited) {
                // Remove from favorites
                await authService.authenticatedFetch(`${API_BASE}/api/favorites/${favoriteId}`, {
                    method: 'DELETE'
                });
                setIsFavorited(false);
                setFavoriteId(null);
                deal.favorite_id = null;
                if (onFavoriteChange) onFavoriteChange(false);
            } else {
                // Add to favorites
                const productId = getProductId();
                if (!productId) {
                    alert('Cannot favorite this product');
                    return;
                }

                const response = await authService.authenticatedFetch(`${API_BASE}/api/favorites`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        marketplace: deal.marketplace,
                        product_id: productId,
                        deal_data: deal,
                        deal_id: deal.id,
                        source: window.location.pathname.includes('storefront') ? 'storefront' :
                            window.location.pathname.includes('a2a') ? 'a2a' :
                                window.location.pathname.includes('wholesale') ? 'wholesale' :
                                    window.location.pathname.includes('reverse-scan') ? 'reverse_scan' :
                                        'live_scan'  // Default fallback
                    })
                });

                const data = await response.json();
                const newFavoriteId = data.favorite_id;
                setIsFavorited(true);
                setFavoriteId(newFavoriteId);
                deal.favorite_id = newFavoriteId;
                if (onFavoriteChange) onFavoriteChange(true);
            }
        } catch (error) {
            console.error('Failed to toggle favorite:', error);
            alert('Failed to update favorites');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <button
                onClick={handleToggleFavorite}
                disabled={loading}
                className={`rounded-full transition-all ${isFavorited
                    ? 'text-red-500 hover:text-red-600 bg-red-50 hover:bg-red-100'
                    : 'text-gray-400 hover:text-red-500 hover:bg-red-50'
                    } ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                title={isFavorited ? 'Remove from favorites' : 'Add to favorites'}
            >
                <Heart
                    size={18}
                    fill={isFavorited ? 'currentColor' : 'none'}
                    className="transition-transform hover:scale-110"
                />
            </button>
            <button
                onClick={() => {
                    const EXT_ID = process.env.REACT_APP_MSP_EXTENSION_ID || 'elebkaoefjdagkbfienaoonkgifogkob';
                    if (window.chrome?.runtime?.sendMessage && EXT_ID) {
                        window.chrome.runtime.sendMessage(EXT_ID, {
                            type: 'MSP_SEARCH_INTENT',
                            marketplace: deal.marketplace,
                            identifier: identifier,
                            title: deal.title,
                            deal,
                        });
                    }
                    window.open(`https://www.google.com/search?q=${encodeURIComponent(deal.title)}&gl=us&hl=en&cr=countryUS`);
                }}
                className="rounded-full p-1 text-gray-400 hover:bg-gray-100 transition-all"
                title="Search on Google"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg"
                    alt="Google"
                    style={{ width: '18px', height: '18px', objectFit: 'contain' }}
                />
            </button>
        </>
    );
};

export default FavoriteButton;